import * as React from 'react'

import ErrorPage from '@src/pages/ErrorPage'
import BaseErrorBoundary from './BaseErrorBoundary'

const StyledErrorBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <BaseErrorBoundary errorView={<ErrorPage />}>{children}</BaseErrorBoundary>
)

export default StyledErrorBoundary



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/StyledErrorBoundary.tsx